export const emailValidator = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email || email.length <= 0) return 'Please enter Email';
  if (!re.test(email)) {
    return 'Enter valid Email';
  }
  return '';
};

export const phoneValidation = phone => {
  if (!phone || phone.length <= 0) return 'Required';
  var phoneno = /^([0-9 ]{10})$/;
  if (!phoneno.test(phone)) {
    return 'Please enter a valid Mobile No';
  }
  return '';
}

export const phoneEmailValidation = phone => {
  if (!phone || phone.length <= 0) return 'Required';
  var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  if (!phoneno.test(phone)) {
    return 'Please enter a valid Mobile No / Email ID';
  }
  return '';
}

export const forgotemailValidator = email => {
  const re = /\S+@\S+\.\S+/;
  if (!email || email.length <= 0) return 'Required';
  if (!re.test(email)) return 'Please enter a valid Email ID';
  return '';
};


export const passwordConfirmValidator = (password, confirm) => {
  if (!password || password.length <= 0) return 'Please enter Confirm Password';
  if (confirm != password) return 'Confirm Password does not match with Password';
  return '';
};

export const nameValidator = value => {
  const re = /^[a-zA-Z .]*$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid Name';
  return '';
};

export const pinCodeValidator = value => {
  const re = /^[0-9]{6}$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter valid PinCode';
  return '';
};

export const IFSCValidator = value => {
  const re = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid IFSC';
  return '';
};

export const accountNoValidator = value => {
  const re = /^\d{9,18}$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid Account Number';
  return '';
};

export const confirmAccountNoValidator = (value, account) => {
  const re = /^\d{9,18}$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid Account Number';
  if (value != account) return 'Account No and Confirm Account No does not mtch'
  return '';
};

export const upiValidator = value => {
  const re = /^\w+@\w+$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid UPI';
  return '';
};

export const panValidator = value => {
  const re = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid PAN No';
  return '';
};

export const gstValidator = value => {
  const re = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid GST';
  return '';
};

export const addressValidator = value => {
  const re = /^[#.0-9a-zA-Z\s, -/]+$/
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter a valid Address';
  return '';
};

export const dropdownValidator = value => {
  if (!value || value.length <= 0) return 'Required';
  return '';
};

export const hoursValidator = value => {
  const re = /([0-1][0-9]|2[0-3]):[0-5][0-9]/
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter valid time format(HH:MM)';
  return '';
};

export const numberValidator = value => {
  const re = /[0-9]/
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter valid hours';
  return '';
};

export const requiredValidator = value => {
  if (!value || value.length <= 0) return 'Required';
  return '';
};

export const alphaValidator = value => {
  const re = /[a-zA-Z]/
  if (!value || value.length <= 0) return 'Required';
  if (!re.test(value)) return 'Please enter valid field';
  return '';
};
export const alphaValidatorWithLabel = (value, label) => {
  const re = /[a-zA-Z]/
  if (!value || value.length <= 0) return 'Please enter ' + label;
  else if (!re.test(value)) return 'Please enter valid ' + label;
  return '';
};
export const nameAlphaValidatorWithLabel = (value, label) => {
  const re = /^[a-zA-Z ]*$/;
  if (!value || value.length <= 0) return 'Please enter ' + label;
  else if (!re.test(value)) return 'Please enter valid ' + label;
  return '';
};
export const ruleValidatorWithLabel = (value, label) => {
  const re = /^[0-9a-zA-Z\s., -/]*$/;
  if (!value || value.length <= 0) return 'Please enter ' + label;
  else if (!re.test(value)) return 'Please enter valid ' + label;
  return '';
};
export const idleTimerequiredValidator = value => {
  if (value == "") return 'Please select Idle Time Interval';
  return '';
};

export const activityrequiredValidator = value => {
  if (value == "") return 'Please select Activity Data Sync';
  return '';
};


export const offlineTimerequiredValidator = value => {
  if (value == "") return 'Please select Offline Time';
  return '';
};

export const requiredWithLabelValidator = (value, label) => {
  if (!value || value.length <= 0) return 'Please enter ' + label;
  return '';
};
export const requiredPasswordWithLabelValidator = (value, label) => {
  const re = /^\S*$/;
  if (!value || value.length <= 0) return 'Please enter ' + label;
  else if (!re.test(value)) return 'Password should not have space'
  else return '';
};
export const dropDownRequiredWithLabelValidator = (value, label) => {
  if (!value || value.length <= 0) return 'Please Select ' + label;
  return '';
};
export const searchAndSelectValidator = (value, label) => {
  if (!value || value.length <= 0) return label == "" ? "Please search and select user(s)" : 'Please Select ' + label;
  return '';
};
export const websiteValidation = (value) => {
  var websiteFormat = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
  if (!websiteFormat.test(value)) {
    return 'please enter valid website'
  }
  else {
    return ''
  }
};

export const getFileExtension = (fileName) => {
  var extensionArray = fileName.split(".")
  var extension = extensionArray[extensionArray.length - 1]
  return extension
};



export const confirmPasswordValidator = (value, account) => {
  if (!value || value.length <= 0) return 'Please enter Confirm Password';
  if (value != account) return 'Password and Confirm password does not match'
  return '';
};

export const passwordValidator = (value) => {
  const sixLetter = /(?=.{6,})/
  const alphaNumeric = /(?=.*[0-9])/
  const uppercase = /(?=.*[A-Z])/
  const lowercase = /(?=.*[a-z])/
  const splCharacter = /(?=.*[!@#\$%\^&\*])/
  if (!value || value.length <= 0) return 'Please enter Password';
  if (!sixLetter.test(value)) return 'Password must be 6 characters';
  if (!alphaNumeric.test(value)) return 'Password must have atleast one number {0-9}';
  if (!uppercase.test(value)) return 'Password must have atleast one capital letter';
  if (!lowercase.test(value)) return 'Password must have atleast one lowercase letter';
  if (!splCharacter.test(value)) return 'Password must have atleast one special character';
  return '';
}
export const passwordConfirmValidatorRequied = (value) => {
  const sixLetter = /(?=.{6,})/
  const alphaNumeric = /(?=.*[0-9])/
  const uppercase = /(?=.*[A-Z])/
  const lowercase = /(?=.*[a-z])/
  const splCharacter = /(?=.*[!@#\$%\^&\*])/
  if (!value || value.length <= 0) return 'Please enter Confirm Password';
  if (!sixLetter.test(value)) return 'Password must be 6 characters';
  if (!alphaNumeric.test(value)) return 'Password must have atleast one number {0-9}';
  if (!uppercase.test(value)) return 'Password must have atleast one capital letter';
  if (!lowercase.test(value)) return 'Password must have atleast one lowercase letter';
  if (!splCharacter.test(value)) return 'Password must have atleast one special character';
  return '';
}
